import { liquidityInfos } from 'config/constants/liquidity';

export const getLiquidity = (chainId: number) => {
  const tokens = liquidityInfos.filter((row: any) => Number(chainId) === Number(row.chainId));
  return tokens;
};